import {
  type Provider,
  ConditionOperatorEnum,
  type Condition,
} from '@repo/api-gw-sdk';

import { cloudProvider } from '../queryBuilder/properties';

export const createCloudProviderCondition = (
  values: Provider[]
): Condition => ({
  property: cloudProvider.name,
  operator: ConditionOperatorEnum.In,
  value: values,
});
